import { CamembertIcon, type CamembertIconProps } from "@images/svgIcons/camembertIcon"
import { clsx, type ClassValue } from "clsx"

export type HuCamembertVariant = "empty" | "partial" | "warning" | "success"

export type HuCamembertProps = {
  variant?: HuCamembertVariant
  number?: number
  className?: ClassValue
} & React.ComponentProps<"div">

const variantStyles: Record<HuCamembertVariant, CamembertIconProps> = {
  empty: {
    color1: "fill-neutral-50",
    color2: "fill-neutral-50",
    color3: "fill-neutral-50",
    strokeColor1: "stroke-neutral-300",
    strokeColor2: "stroke-neutral-300",
    strokeColor3: "stroke-neutral-300",
  },
  partial: {
    // bg-neutral-50: #f5f5f5, bg-red-500: #ef4444, border-neutral-300: #d4d4d4, border-black
    color1: "fill-neutral-50",
    color2: "fill-red-500",
    color3: "fill-neutral-50",
    strokeColor1: "stroke-neutral-300",
    strokeColor2: "stroke-neutral-900",
    strokeColor3: "stroke-neutral-300",
  },
  warning: {
    // bg-yellow-500: #f59e0b, bg-neutral-50: #f5f5f5, border-black, border-neutral-300
    color1: "fill-custom-yellow-500",
    color2: "fill-custom-yellow-500",
    color3: "fill-neutral-50",
    strokeColor1: "stroke-neutral-900",
    strokeColor2: "stroke-neutral-900",
    strokeColor3: "stroke-neutral-300",
  },
  success: {
    // bg-green-500: #22c55e, border-black
    color1: "fill-custom-green-500",
    color2: "fill-custom-green-500",
    color3: "fill-custom-green-500",
    strokeColor1: "stroke-neutral-900",
    strokeColor2: "stroke-neutral-900",
    strokeColor3: "stroke-neutral-900",
  },
}

/**
 * Convertit un number en variant correspondant
 * @param number - Le nombre (0-3) correspondant à l'ancienne API
 * @returns Le variant correspondant
 */
function getVariantFromNumber(number: number): HuCamembertVariant {
  if (number < 0 || number > 3) {
    return "empty"
  }

  switch (number) {
    case 0:
      return "empty"
    case 1:
      return "partial"
    case 2:
      return "warning"
    case 3:
      return "success"
    default:
      return "empty"
  }
}

export function HuCamembert({ variant, number, className, ...props }: HuCamembertProps) {
  // Priorité au variant explicite, sinon utilise le number pour déterminer le variant
  const finalVariant = variant ?? (number !== undefined ? getVariantFromNumber(number) : "empty")
  const camembertProps = variantStyles[finalVariant]

  return (
    <div className={clsx("inline-block", className)} {...props}>
      <CamembertIcon {...camembertProps} />
    </div>
  )
}
